import { useState } from "react";
import logo from "../assets/FairLegal_logo_transparent_background.png";
import { Menu, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <header className="bg-gray-200 rounded-2xl shadow-sm px-4 sm:px-6 lg:px-8 relative">
            <div className="flex justify-between items-center h-24">
                {/* Logo */}
                <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-2">
                        <div onClick={() => navigate("/")} className="w-20 h-20 rounded-lg flex items-center justify-center overflow-hidden">
                            <img
                                src={logo}
                                alt="FairLegal Logo"
                                className="w-full h-full object-contain"
                            />
                        </div>
                    </div>
                </div>

                {/* Desktop Navigation */}
                <div className="hidden lg:flex items-center space-x-12">
                    <a
                        href="/consent-page"
                        className="text-gray-800 hover:text-black text-lg font-medium transition-colors duration-200"
                    >
                        Όροι χρήσης
                    </a>
                    <a
                        href="https://fairlegal.gr/schetika-me-to-ergo/" target="_blank"
                        className="text-gray-800 hover:text-black text-lg font-medium transition-colors duration-200"
                    >
                        Σχετικά με μας
                    </a>
                    <a
                        href="#"
                        className="text-gray-800 hover:text-black text-lg font-medium transition-colors duration-200"
                    >
                        Οδηγός χρήσης
                    </a>
                    <a
                        href="https://fairlegal.gr/epikoinonia/" target="_blank"
                        className="text-gray-800 hover:text-black text-lg font-medium transition-colors duration-200"
                    >
                        Επικοινωνία
                    </a>
                </div>

                {/* Burger Menu Button */}
                <div className="lg:hidden">
                    <button
                        onClick={toggleMenu}
                        className="text-gray-800 hover:text-black transition-colors duration-200 focus:outline-none"
                        aria-label="Toggle menu"
                    >
                        {isMenuOpen ? (
                            <X className="w-6 h-6" />
                        ) : (
                            <Menu className="w-6 h-6" />
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile/Tablet Navigation Menu */}
            <div
                className={`${
                    isMenuOpen ? "block" : "hidden"
                } lg:hidden relative transition-all duration-300 ease-in-out `}
            >
                <div className="space-y-0 lg:space-y-4">
                    <a
                        href="/consent-page"
                        className="text-gray-800 hover:text-black text-lg font-medium transition-colors duration-200"
                    >
                        Όροι χρήσης
                    </a>
                    <a
                        href="https://fairlegal.gr/schetika-me-to-ergo/" target="_blank"
                        onClick={closeMenu}
                        className="block text-gray-800 hover:text-black text-lg font-medium transition-colors duration-200 py-1 lg:py-2"
                    >
                        Σχετικά με μας
                    </a>
                    <a
                        href="#"
                        onClick={closeMenu}
                        className="block text-gray-800 hover:text-black text-lg font-medium transition-colors duration-200 py-1 lg:py-2"
                    >
                        Οδηγός χρήσης
                    </a>
                    <a
                        href="https://fairlegal.gr/epikoinonia/" target="_blank"
                        onClick={closeMenu}
                        className="block text-gray-800 hover:text-black text-lg font-medium transition-colors duration-200 py-1 lg:py-2"
                    >
                        Επικοινωνία
                    </a>
                </div>
            </div>
        </header>
    );
};

export default Header;
